(function () {
  const TARGET_PRODUCT_HANDLES = [
    'choco-banana-10-bars-copy',
    'strawberry-10-bars-copy',
    'chocolate-chip-10-bars-copy'
  ];

  const WIDGET_ROOT_SELECTOR = 'kaching-bundle';
  const BAR_SELECTOR = 'kaching-bundle .kaching-bundles__bars--horizontal .kaching-bundles__bar';
  const RADIO_SELECTOR = 'kaching-bundle .kaching-bundles__bar input[type="radio"]';
  const ADD_TO_CART_SELECTOR = 'button[type="submit"][name="add"]';

  // Price matrix: [barIndex][supplyIndex]
  const PRICE_MATRIX = {
    0: { // subscribe
      0: '$1.80/bar',
      1: '$1.70/bar',
      2: '$1.60/bar',
    },
    1: { // one-time
      0: '$1.90/bar',
      1: '$1.80/bar',
      2: '$1.70/bar',
    },
  };

  const isTargetProduct = TARGET_PRODUCT_HANDLES.some(handle =>
    window.location.pathname.includes(`/products/${handle}`)
  );
  
  if (!isTargetProduct) {
    return;
  }

  function waitForWidget(callback) {
    const interval = setInterval(() => {
      const widget = document.querySelector(WIDGET_ROOT_SELECTOR);
      const bars = document.querySelectorAll(BAR_SELECTOR);

      if (widget && bars.length >= 2) {
        clearInterval(interval);
        callback();
      }
    }, 100);
  }

  function getSelectedBarIndex() {
    const bars = Array.from(document.querySelectorAll(BAR_SELECTOR));
    return bars.findIndex(bar =>
      bar.classList.contains('kaching-bundles__bar--selected')
    );
  }

  function getSelectedSupplyIndex() {
    const radios = Array.from(document.querySelectorAll(RADIO_SELECTOR));
    return radios.findIndex(radio => radio.checked);
  }

  function updatePriceText() {
    const barIndex = getSelectedBarIndex();
    if (barIndex === -1) return;

    const supplyIndex = getSelectedSupplyIndex();
    if (supplyIndex === -1) return;

    const priceText = PRICE_MATRIX[barIndex]?.[supplyIndex];
    
    if (!priceText) return;

    const addToCartBtn = document.querySelector(ADD_TO_CART_SELECTOR);
    if (!addToCartBtn) return;

    let priceEl = addToCartBtn.querySelector('.dynamic-price');

    if (!priceEl) {
      priceEl = document.createElement('span');
      priceEl.className = 'dynamic-price';
      priceEl.style.marginLeft = '8px';
      priceEl.style.fontWeight = '500';
      addToCartBtn.appendChild(priceEl);
    }
    
    const finalPriceText = " | " + priceText; 
    priceEl.textContent = finalPriceText;
  }

  function bindEvents() {
    const bars = document.querySelectorAll(BAR_SELECTOR);

    bars.forEach(bar => {
      bar.addEventListener('click', () => {
        updatePriceText();
      });
    });

    const radios = document.querySelectorAll(RADIO_SELECTOR);

    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        updatePriceText();
      });
    });
  }

  waitForWidget(() => {
    bindEvents();
    updatePriceText(); // initial render
  });
})();
